import React, { memo, useEffect, useState } from 'react'
import { left_arrow, logo } from '../../assets/imgs'
import { useNavigate } from 'react-router-dom'
import { useRazorpay } from 'react-razorpay'
import { RAZORPAY_KEY } from '../redux/api/Constants'
import { usePropertyMmcPaymentMutation, usePropertyMmcResponseMutation } from '../redux/api/api'
import { toast } from 'react-toastify'

const MmcPayment = ({ data, owner_id, property_id }) => {
    const navigate = useNavigate()


    console.log(owner_id, property_id, 'owner_id,property_id');

    const [MmcPaymentApi] = usePropertyMmcPaymentMutation()
    const [MmcResponseApi] = usePropertyMmcResponseMutation()
    const [loading, setLoading] = useState(false)


    console.log(data?.data, 'daatId')


    const submitPaymentHandler = (status, id) => {
        setLoading(true)
        let payload = {
            status: status,
            subscription_id: id
        }
        MmcResponseApi(payload)
            .unwrap()
            .then((res) => {
                console.log('responseRes', res)
                if (res?.status == 'success') {
                    toast.success(res?.message)
                    setLoading(false)
                    navigate('/property')
                }
            }).catch((err) => {
                console.log('responseErr', err)
                toast.error(err?.message ? err?.message : err?.data?.message)
                setLoading(false)
            })


    }


    const { error, isLoading, Razorpay } = useRazorpay();

    const handlePayment = (order_id) => {
        const options: RazorpayOrderOptions = {
            key: RAZORPAY_KEY,
            subscription_id: order_id,
            amount: 1180,
            currency: "INR",
            name: "ZIRO",
            description: "ZIRO",
            image: logo,
            handler: (response) => {
                console.log('reazorpayResponse', response)
                if (response?.razorpay_subscription_id) {
                    submitPaymentHandler("success", response?.razorpay_subscription_id);
                } else {
                    submitPaymentHandler("failed", response?.razorpay_subscription_id);
                }
            },
            prefill: {
                name: data?.data?.owner?.name,
                email: data?.data?.owner?.email || null,
                contact: data?.data?.owner?.mobile || null,
            },
            theme: {
                color: "#0d7aa8",
            },

        };

        const razorpayInstance = new Razorpay(options);
        razorpayInstance.open();
    };


    const handleMMC = () => {
        let payload = {
            owner_id: data?.data?.owner_id ? data?.data?.owner_id : owner_id,
            property_id: data?.data?.id ? data?.data?.id : property_id,
            subscription_status: 1,
            notification: 1
        }
        setLoading('init')
        console.log('mmcPayload', payload)
        MmcPaymentApi(payload)
            .unwrap()
            .then((res) => {
                if (res?.status == 'success') {
                    console.log(res, 'mmc_res')
                    setLoading(false)
                    toast.success(res?.message)
                    if (res?.data?.rz_subscription_id) {
                        handlePayment(res?.data?.rz_subscription_id)
                    }
                }
            }).catch((err) => {
                console.log('mmcErr', err)
                setLoading(false)
            })

    }





    return (
        <div className='mt-2'>
            <div className="d-flex ac-js pointer gap-2">
                <img
                    src={left_arrow}
                    className="leftArrow mb-3 pointer"
                    onClick={() => navigate(-1)}
                    alt="Back"
                />
                <p
                    className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
                    onClick={() => navigate(-1)}
                >
                    Back
                </p>
            </div>

            <div className='vh-50 d-flex ac-jc'>
                <div class="shadow p-3 mb-5 bg-body rounded">
                    <h4 className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 mt-3 primary">
                        Activate the free Subscription of 90 days. After 90 days the auto detection of RS. 1180 incl  GST will be
                    </h4>
                    <h4 className="f2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 mt-3 primary text-center">
                        auto debited.
                    </h4>

                    <div className="d-flex ac-jc mt-3">
                        <button
                            className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3"
                            onClick={handleMMC}
                            disabled={loading}
                        >
                            {loading ? (
                                <div className="spinner-border spinner-border-sm"></div>
                            ) : (
                                "Activate Free Subscription"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(MmcPayment)